import { useQuery } from 'react-query';

import {
  type RecommendedProjectsResponse,
  getRecommendedProjects,
} from '@utils/backend-api/projects';

const RECOMMENDED_PROJECTS_KEY = 'RECOMMENDED_PROJECTS';

export default function useRecommendedProjects(mostReadTopic?: string) {
  const { data, isLoading } = useQuery<RecommendedProjectsResponse>(
    [RECOMMENDED_PROJECTS_KEY, mostReadTopic],
    () => getRecommendedProjects(mostReadTopic)
  );

  return { projects: data?.projects, isLoadingProjects: isLoading };
}
